<template>
  <div ref="popover" class="popover bs-tether-element bs-tether-element-attached-top bs-tether-element-attached-center bs-tether-target-attached-bottom bs-tether-target-attached-center fade bs-tether-enabled show">
       <!--style="top: 0px; left: 0px; position: absolute; transform: translateX(710.469px) translateY(671px) translateZ(0px);">-->
    <div class="popover-title">
      <div class="text-center">
        <trans-text i18nKey="ui['5_1_2'][1]"/>
      </div>
    </div>
    <div class="popover-content">
      <div class="form-group row mb-0" >
        <label class="col-4 col-form-label px-2"><small><trans-text i18nKey="ui['5_1_2'][2]"/></small></label>
        <div class="col-8">
          <input class="form-control transparent-input" type="text" value="" placeholder="123abc" autocapitalize="off" v-model.trim="input.event_key" @change="$v.input.event_key.$touch()" >
        </div>
        <p class="col-12 my-0 form-control-feedback">
          <input-feedback :validate-for-input="$v.input.event_key" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_1'][5]"/></input-feedback>
          <input-feedback :validate-for-input="$v.input.event_key" type="alphaNum"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_1'][6]"/></input-feedback>
          <input-feedback :validate-for-input="$v.input.event_key" type="stringLength"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_1'][7]"/></input-feedback>

          <span class="form-control-feedback" v-if="apiErrorI18nKey"><i class="fa fa-asterisk" aria-hidden="true"></i> <trans-text :i18nKey="apiErrorI18nKey"/></span>
        </p>
        <div class="col-12 form-hr">
          <hr class="">
        </div>
      </div>
      <div class="text-center">
        <button class="btn btn-danger" type="button" @click="tryForm">
          <trans-text i18nKey="ui['5_1_2'][3]"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import {required,alphaNum,stringLength} from 'systems/validators'
  import FormPartialBase from 'extends/FormPartialBase.vue'
  import Event from 'processor/Event'

  export default {
    name:"",
    extends:FormPartialBase,
    components: {
    },
    props:["provisionalRouteTo"],
    data () {
      return {
        apiErrorI18nKey:null,
        input: {
          event_key: "",
        },
      }
    },
    validations: {
      input: {
        event_key: {
          required,
          alphaNum,
          stringLength: stringLength(6)
        },
      },
    },
    created(){

    },
    mounted(){
    },
    methods:{
      tryForm(e){
        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }
        Event.eventKeyActivation(Object.assign(this.input,{"event_id":this.provisionalRouteTo.params.event_id}))
          .then((res)=>{
            if(res.status === "ng"){
              this.apiErrorI18nKey = res.apiErrorI18nKey
              return
            }
            return this.$router.push({ name: 'mypage::event::catalog', params: {"event_id":this.provisionalRouteTo.params.event_id}})
          })
      },
    }
  }
</script>


<style lang="scss" scoped>
  .popover.bs-tether-element-attached-top::after,
  .popover.bs-tether-element-attached-top::before{
    left: 80%;
  }
  .popover-title{
    background-color: #fef7ea;
    font-size: .9rem;
  }
</style>



// WEBPACK FOOTER //
// AddEventKeyPopover.vue?62c38392